import { MutableRefObject, useEffect } from "react";

export const useFloatingResizer = (
  floatingRef: MutableRefObject<HTMLElement | null>,
  update: () => void
) => {
  useEffect(() => {
    const parentElement = floatingRef.current?.parentElement;
    if (!parentElement || !(parentElement instanceof HTMLElement)) return;

    const handleViewportResize = () => update();

    const observer = new ResizeObserver(handleViewportResize);
    window.visualViewport?.addEventListener("resize", handleViewportResize);

    observer.observe(parentElement);

    return () => {
      observer.disconnect();
      window.visualViewport?.removeEventListener("resize", handleViewportResize);
    };
  }, [floatingRef, update]);
};
